import { Fingerprint } from "./fingerprint";
import { Cargo } from "./cargo";
import { TransportCompany } from "./transportCompany";

export enum PreBillState {
    Created = 'Created',
    Cashed = 'Cashed',
    Deleted = 'Deleted'
}

export interface PreBill {
    id: string;
    consecutive: number;
    state: PreBillState;
    createdBy: Fingerprint;
    companyId?: string;
    validated?: boolean;
    validatedBy?: Fingerprint;
    total?: number;
    cargoCount?: number;
    cargos?: Cargo[];
    // Empresa de transporte de la prefactura (id = NIT, como en los servicios): define con qué empresa se factura.
    transportCompany?: TransportCompany;
}
